import script from "./TextbookCollection.vue?vue&type=script&setup=true&lang=js"
export * from "./TextbookCollection.vue?vue&type=script&setup=true&lang=js"

import "./TextbookCollection.vue?vue&type=style&index=0&id=1c5f4d00&lang=scss&scoped=true"

import exportComponent from "K:\\宫俊勇\\青桔pc官网wf-qjgw\\wf-qjgw\\node_modules\\@vue\\cli-service\\node_modules\\vue-loader-v16\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-1c5f4d00"]])

export default __exports__